import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e2d9d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "no" }
const _hoisted_8 = ["name"]
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "toolbar" }
const _hoisted_13 = { class: "book" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "nofound"
}
const _hoisted_16 = {
  key: 1,
  class: "page-default page-media"
}
const _hoisted_17 = { class: "page-main" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "no" }
const _hoisted_22 = ["name"]
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "toolbar" }
const _hoisted_27 = ["title"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-left" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["title"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon i-guanbi" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))

import backMusic, { State as MusicState } from '@/store/backMusic';
import bible, { State } from '@/store/bible/detail';
import contents from '@/views/assets/contents';
import { computed, onBeforeUnmount, onMounted, reactive, watch, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';
import { setting } from '@/config'
import { isMobile } from '@/common/download'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const data = computed<State>(() => store.state[bible.name])
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].bible)

const musicData = computed<MusicState>(() => store.state[backMusic.name])
const biblePlaying = computed(() => musicData.value.bible && musicData.value.list.length > 0)
const volume = computed(() => contents[data.value.volume])
const fontSize = computed(() => ({ fontSize: data.value.font + 'px' }))
const frame = ref<HTMLIFrameElement>()
const state = reactive({
    height: 0,
    selected: -1,
    subIndex: -1,
    goTopVisible: false,
    leftWidth: 500,
    draging: false,
})
const innerPath = computed(() => `/bibles/0/${data.value.volume + 1}/${data.value.chapter + 1}/${data.value.bookSid}`)
watch(() => musicData.value.chapter, onMusicChange)
watch(() => data.value.lang, onLangChange)
watch(() => route.fullPath, logRead)
watch(() => musicData.value.currentTime, onAudioCurrentTimeUpdate)
watch(biblePlaying, onBiblePlayChanged)
watch(() => data.value.font, () => {
    if (frame.value && frame.value.contentWindow) {
        frame.value.contentWindow.postMessage({ key: 'setFontSize', value: data.value.font }, '*')
    }
})
watch(() => data.value.color, () => {
    if (frame.value && frame.value.contentWindow) {
        frame.value.contentWindow.postMessage({ key: 'setColor', value: data.value.color == 4 ? '#CCC' : '#3D3D3D' }, '*')
    }
})
watch(frame, () => {
    if (frame.value && frame.value.contentWindow) {
        console.info('frame on')
        window.addEventListener('message', function (e) {
            if (e.data == 'ready') {
                console.info('iframe ready')
                if (frame.value && frame.value.contentWindow) {
                    frame.value.contentWindow.postMessage({ key: 'setFontSize', value: data.value.font }, '*')
                    frame.value.contentWindow.postMessage({ key: 'setColor', value: data.value.color == 4 ? '#CCC' : '#3D3D3D' }, '*')
                }
            }
        })
    }
})
onMounted(() => {
    let font = window.localStorage.getItem('bfont')
    if (font) {
        data.value.font = parseInt(font)
    }
    let color = window.localStorage.getItem('bcolor')
    if (color) {
        data.value.color = parseInt(color)
    }
    window.addEventListener('resize', onResize)
    window.addEventListener('scroll', onScroll)
    document.addEventListener('copy', onCopy)
    onResize()
    logRead()

    if (route.query.l) {
        bible.setVersions(store, [route.query.l as string])
    } else {
        let vers = window.localStorage.getItem('bVers')
        if (vers) {
            bible.setVersions(store, vers.split(','))
        } else {
            bible.setVersions(store, ['hhb'])
        }
        if (musicData.value.bible && musicData.value.list.length > 0) {
            backMusic.playBible(store, data.value.volume, data.value.chapter, data.value.lang)
        }
    }

    if (isMobile() && setting.first) {
        window.location.href = 'fuyintv://ttlx/bible/' + data.value.volume + '/' + data.value.chapter
    }
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize)
    window.removeEventListener('scroll', onScroll)
    document.removeEventListener('copy', onCopy)
})

function onScroll() {
    state.goTopVisible = window.scrollY > 300
}

async function onCopy(e: any) {
    let myText = data.value.lang == 'niv' ? `（${volume.value.english} chapter ${data.value.chapter + 1} selection）` : `（${volume.value.name}${data.value.chapter + 1}章节选）`;
    //@ts-ignore
    let clipboardData = e.clipboardData || window.clipboardData;
    if (!clipboardData) {
        return
    }
    //@ts-ignore
    let result = window.getSelection().toString() + ":" + myText;
    e.preventDefault();
    clipboardData.setData('text', result);
}

function logRead() {
    window.localStorage.setItem('blast', `${data.value.volume}-${data.value.chapter}`)
    setTimeout(checkScroll, 20);
}

function onMusicChange() {
    router.push({
        name: 'bible-detail',
        params: {
            volume: musicData.value.volume + 1,
            chapter: musicData.value.chapter + 1,
            lang: '0',
        }
    })
}
function checkScroll() {
    state.selected = -1
    if (data.value.contents.length > 0 && window.location.hash) {
        let name = window.location.hash.substr(1)
        setTimeout(() => {
            for (let anchor of document.anchors) {
                if (anchor.name == name) {
                    let rect = anchor.getBoundingClientRect()
                    window.scrollTo(0, window.scrollY + rect.top - 70)
                    state.selected = parseInt(name.substr(1))
                }
            }
        }, 20);
    }
}

function onResize() {
    state.height = window.innerHeight - 60
}

function goTo(volume: number, chapter: number) {
    router.push({
        name: 'bible-detail',
        params: {
            volume: volume + 1,
            chapter: chapter + 1,
            lang: '0',
        }
    })
    if (musicData.value.bible && musicData.value.list.length > 0) {
        backMusic.playBible(store, volume, chapter, data.value.lang)
    }
}

function onChapter(i: number) {
    goTo(data.value.volume, i)
}
function onGoPrev() {
    let volume = data.value.volume
    let chapter = data.value.chapter - 1
    if (chapter < 0) {
        volume--
        if (volume < 0) {
            return
        }
        chapter = contents[volume].chapters - 1
    }
    goTo(volume, chapter)
}

function onGoNext() {
    let volume = data.value.volume
    let chapter = data.value.chapter + 1
    if (chapter >= contents[volume].chapters) {
        volume++
        if (volume >= contents.length) {
            return
        }
        chapter = 0
    }
    goTo(volume, chapter)
}

function onGoTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
}

function onLangChange() {
    if (musicData.value.bible && musicData.value.list.length > 0) {
        backMusic.playBible(store, data.value.volume, data.value.chapter, data.value.lang,)
    }
}

function onPlayAudio() {
    backMusic.playBible(store, data.value.volume, data.value.chapter, data.value.lang,)
}

function onAudioCurrentTimeUpdate() {
    if (musicData.value.bible && musicData.value.currentTime > 0) {
        let item = musicData.value.subtitle.find(item => item.s <= musicData.value.currentTime && item.e >= musicData.value.currentTime)
        if (item) {
            if (state.subIndex != item.id) {
                state.subIndex = item.id
                let e = document.getElementsByClassName('pt' + item.id)
                if (e.length > 0) {
                    let rect = e[0].getBoundingClientRect()
                    let y = rect.top + window.scrollY - 100
                    window.scrollTo({
                        left: 0,
                        top: y,
                        behavior: 'smooth'
                    })
                }
            }
        } else {
            state.subIndex = -1
        }
    }
}
function onBiblePlayChanged() {
    if (biblePlaying.value) {
    } else {
        state.subIndex = -1
    }
}

function getPClass(item: any) {
    let classnames = ['pt' + item.i]
    if (state.subIndex == item.i) {
        classnames.push('sub')
    }
    return classnames
}

const double = ref<HTMLDivElement>()
function onMouseDownDrag(e: MouseEvent) {
    let x = e.clientX
    let max = 0
    if (double.value) {
        max = double.value.clientWidth
    }
    state.draging = true
    document.onmousemove = function (e1: MouseEvent) {
        let offset = e1.clientX - x
        x = e1.clientX
        state.leftWidth += offset
        if (state.leftWidth < 200) {
            state.leftWidth = 200
        } else if (max - state.leftWidth < 200) {
            state.leftWidth = max - 200
        }
    }
    document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
        state.draging = false
    }
}

function onCloseBook() {
    bible.quitBook(store)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", 'c' + _unref(data).color])
  }, [
    _createElementVNode("div", {
      class: "chapters",
      style: _normalizeStyle({ height: _unref(state).height + 'px' })
    }, [
      _createElementVNode("div", null, _toDisplayString(_unref(lang).chapter), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(volume).chapters, (n, i) => {
        return (_openBlock(), _createElementBlock("a", {
          class: _normalizeClass({ on: _unref(data).chapter == i }),
          onClick: ($event: any) => (onChapter(i))
        }, _toDisplayString(n), 11, _hoisted_1))
      }), 256))
    ], 4),
    (_unref(data).doubleMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "page-double",
          ref_key: "double",
          ref: double,
          style: _normalizeStyle({ height: _unref(state).height + 'px' })
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["bible", { lock: _unref(state).draging }]),
            style: _normalizeStyle({ width: _unref(state).leftWidth + 'px' })
          }, [
            _createElementVNode("div", {
              class: "page-path path-links",
              style: _normalizeStyle(_unref(fontSize))
            }, [
              (_unref(data).lang == 'niv')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(volume).english) + " - " + _toDisplayString(_unref(data).chapter + 1), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(volume).name) + " - " + _toDisplayString(_unref(data).chapter + 1), 1))
            ], 4),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).contents, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (item.i == 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "topic",
                        innerHTML: item.vers[0].text
                      }, null, 8, _hoisted_6))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["section", getPClass(item)]),
                        style: _normalizeStyle(_unref(fontSize))
                      }, [
                        _createElementVNode("span", _hoisted_7, [
                          _createElementVNode("a", {
                            name: 's' + item.i
                          }, _toDisplayString(item.i), 9, _hoisted_8)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.vers, (ver) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (item.vers.length > 1)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_10, "[" + _toDisplayString(ver.ver) + "]", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: _normalizeClass({ selected: _unref(state).selected == item.i }),
                              innerHTML: ver.text
                            }, null, 10, _hoisted_11)
                          ]))
                        }), 256))
                      ], 6))
                ]))
              }), 256)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", { onClick: onGoPrev }, _toDisplayString(_unref(lang).prev), 1),
                _createElementVNode("a", { onClick: onPlayAudio }, _toDisplayString(_unref(lang).playAudio), 1),
                _createElementVNode("a", { onClick: onGoNext }, _toDisplayString(_unref(lang).next), 1)
              ])
            ])
          ], 6),
          _createElementVNode("div", {
            class: "spline",
            onMousedown: onMouseDownDrag
          }, null, 32),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "page-path path-links",
              style: _normalizeStyle(_unref(fontSize))
            }, _toDisplayString(_unref(lang).book) + "：" + _toDisplayString(_unref(data).bookTitle), 5),
            _createElementVNode("div", {
              class: _normalizeClass(["content book-html", { lock: _unref(state).draging }]),
              style: _normalizeStyle(_unref(fontSize))
            }, [
              (_unref(data).bookContent)
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    ref_key: "frame",
                    ref: frame,
                    src: _unref(innerPath)
                  }, null, 8, _hoisted_14))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(lang).book_notfound), 1))
            ], 6)
          ])
        ], 4))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).contents, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (item.i == 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "topic",
                        innerHTML: item.vers[0].text
                      }, null, 8, _hoisted_20))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["section", getPClass(item)]),
                        style: _normalizeStyle(_unref(fontSize))
                      }, [
                        _createElementVNode("span", _hoisted_21, [
                          _createElementVNode("a", {
                            name: 's' + item.i
                          }, _toDisplayString(item.i), 9, _hoisted_22)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.vers, (ver) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (item.vers.length > 1)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_24, "[" + _toDisplayString(ver.ver) + "]", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: _normalizeClass({ selected: _unref(state).selected == item.i }),
                              innerHTML: ver.text
                            }, null, 10, _hoisted_25)
                          ]))
                        }), 256))
                      ], 6))
                ]))
              }), 256)),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("a", { onClick: onGoPrev }, _toDisplayString(_unref(lang).prev), 1),
                _createElementVNode("a", { onClick: onPlayAudio }, _toDisplayString(_unref(lang).playAudio), 1),
                _createElementVNode("a", { onClick: onGoNext }, _toDisplayString(_unref(lang).next), 1)
              ])
            ])
          ])
        ])),
    (!_unref(data).doubleMode)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          class: "gobtn go-prev",
          title: _unref(lang).prev,
          onClick: onGoPrev
        }, _hoisted_29, 8, _hoisted_27))
      : _createCommentVNode("", true),
    (!_unref(data).doubleMode)
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          class: "gobtn go-next",
          title: _unref(lang).new,
          onClick: onGoNext
        }, _hoisted_32, 8, _hoisted_30))
      : _createCommentVNode("", true),
    (_unref(state).goTopVisible)
      ? (_openBlock(), _createElementBlock("a", {
          key: 4,
          class: "gobtn go-top",
          onClick: onGoTop
        }, _hoisted_34))
      : _createCommentVNode("", true),
    (_unref(data).doubleMode)
      ? (_openBlock(), _createElementBlock("a", {
          key: 5,
          class: "gobtn go-close",
          onClick: onCloseBook
        }, _hoisted_36))
      : _createCommentVNode("", true),
    _hoisted_37
  ], 2))
}
}

})